<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  searchQuery: {
    type: String,
    required: false,
    default: '',
  },
  hasRecords: {
    type: Boolean,
    required: true,
  },
  pageNumber: {
    type: Number,
    required: true,
  },
  hasAppliedFilters: {
    type: Boolean,
    required: true,
  },
});

const { t } = useI18n();

const showEmptyStateLayout = computed(() => {
  return (
    !props.searchQuery &&
    !props.hasRecords &&
    props.pageNumber === 1 &&
    !props.hasAppliedFilters
  );
});

const showEmptyText = computed(() => {
  return (
    (props.searchQuery || props.hasAppliedFilters || props.pageNumber > 1) &&
    !props.hasRecords
  );
});

const emptyStateMessage = computed(() => {
  if (props.searchQuery)
    return t('WGPT_AUDIT_TRAIL.EMPTY_STATE.SEARCH_EMPTY_STATE_TITLE');
  if (props.hasAppliedFilters)
    return t('WGPT_AUDIT_TRAIL.EMPTY_STATE.LIST_EMPTY_STATE_TITLE');
  return t('WGPT_AUDIT_TRAIL.EMPTY_STATE.TITLE');
});
</script>

<template>
  <div
    v-if="showEmptyStateLayout"
    class="pt-14 w-full flex flex-col items-center justify-center gap-3"
  >
    <h2
      class="text-3xl font-medium text-center text-n-slate-12 font-interDisplay"
    >
      {{ t('WGPT_AUDIT_TRAIL.EMPTY_STATE.TITLE') }}
    </h2>

    <p
      class="max-w-xl text-base text-center text-n-slate-11 font-interDisplay tracking-[0.3px]"
    >
      {{ t('WGPT_AUDIT_TRAIL.EMPTY_STATE.SUBTITLE') }}
    </p>
  </div>
  <div v-else-if="showEmptyText">
    <div class="flex items-center justify-center py-10">
      <span class="text-base text-n-slate-11">
        {{ emptyStateMessage }}
      </span>
    </div>
  </div>
</template>
